import { PawPrint } from 'lucide-react'

import type { PublicPatient } from '@snootsvet/shared/portal'

import {
  EditActions,
  EditableField,
  EditableValue,
  EditButton,
  useEditableField,
} from '@/customer/components/editable-field'
import { Input } from '@/customer/components/ui/input'
import { useUpdatePet } from '@/customer/hooks/use-update-pet'

/**
 * Pet name row. Always editable - name changes don't touch clinical
 * history.
 */
export function NamePetField({ pet }: { pet: PublicPatient }) {
  const updatePet = useUpdatePet(pet.id)
  const nameField = useEditableField({
    initialValue: pet.name,
    onSave: async ({ value, setError }) => {
      const trimmed = value.trim()
      if (!trimmed) return setError('Please enter a name.')
      if (trimmed === pet.name) return
      try {
        await updatePet.mutateAsync({ name: trimmed })
      } catch {
        setError('Something went wrong saving. Please try again.')
      }
    },
  })

  return (
    <EditableField
      label="Name"
      icon={PawPrint}
      error={nameField.error}
      action={<EditButton field={nameField} label="name" />}
    >
      {nameField.isEditing ? (
        <Input
          autoFocus
          variant="underline"
          value={nameField.draft}
          onChange={(e) => nameField.setDraft(e.target.value)}
          autoComplete="off"
        />
      ) : (
        <EditableValue>{pet.name}</EditableValue>
      )}
      <EditActions field={nameField} />
    </EditableField>
  )
}
